import React from 'react';

// Modules
import RedirectToTargetLandingPage from 'core/modules/RedirectToTargetLandingPage/RedirectToTargetLandingPage';
import PageErrorBoundary from 'core/modules/ErrorBoundaries/PageErrorBoundary';
import ErrorMessage from 'core/modules/ErrorMessage/ErrorMessage';

function Error() {
  return (
    <RedirectToTargetLandingPage>
      <PageErrorBoundary>
        <div className="mn_error" data-test="error">
          <ErrorMessage />
        </div>
      </PageErrorBoundary>
    </RedirectToTargetLandingPage>
  );
}

export default Error;
